import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeaf, faGlobe, faUsers, faBox } from "@fortawesome/free-solid-svg-icons";

import Navbar from "../Components/Navbar";
import WhatsAppChat from "./WhatsAppChat";
import aboutimage1 from "../images/about/aboutimage1.jpg"
import aboutimage2 from "../images/about/aboutimage2.jpg"
import aboutimage3 from "../images/about/aboutimage3.jpg"
import aboutimage4 from "../images/about/aboutimage4.jpg"

import ourvision from "../images/about/ourvision.webp"
import ourmission from "../images/about/ourmission.jpeg"

import ExportCountries from "./ExportCountries";
import ClientStories from "./ClientStories";

import gstPdf from "../images/gst-certificate/gst-certificate.pdf";
import gstPreview from "../images/gst-certificate/gst-preview.png";

export default function About() {

  const images = [
    aboutimage4,
    aboutimage1,
    aboutimage2,
    aboutimage3,
    // "https://images.unsplash.com/photo-1471193945509-9ad0617afabf"
  ];

  const [currentImage, setCurrentImage] = useState(0);
  const [showPdf, setShowPdf] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 2000); // 2 seconds

    return () => clearInterval(interval);
  }, []);
  // SCROLL REVEAL EFFECT
  useEffect(() => {
    const reveals = document.querySelectorAll(".reveal");
    const counters = document.querySelectorAll(".counter");

    let started = false; // prevent repeat animation

    const handleScroll = () => {
      // REVEAL ANIMATION
      reveals.forEach((el) => {
        const windowHeight = window.innerHeight;
        const elementTop = el.getBoundingClientRect().top;

        if (elementTop < windowHeight - 100) {
          el.classList.add("active");
        }
      });

      // COUNTER ANIMATION (trigger once)
      const statsSection = document.querySelector(".stats-section");

      if (!started && statsSection) {
        const top = statsSection.getBoundingClientRect().top;

        if (top < window.innerHeight - 100) {
          counters.forEach((counter) => {
            const target = +counter.getAttribute("data-target");
            let count = 1;

            const updateCount = () => {
              const increment = target / 50; // speed control

              if (count < target) {
                count += increment;
                counter.innerText = Math.ceil(count) + "+";
                setTimeout(updateCount, 30);
              } else {
                counter.innerText = target + "+";
              }
            };

            updateCount();
          });

          started = true;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <div className="about-container">

        {/* HERO SECTION */}
        <section className="about-hero reveal">
          <div className="about-text">
            <h4>
              About Us
            </h4>
            <h1 className="about-title">
              Unique Global Exports
            </h1>

            <p>
              We are a trusted exporter of premium quality{" "}
              <b>Fruits, Vegetables, and Spices from India</b> to global markets,
              serving clients across the Middle East, Europe, Southeast Asia, and beyond.
              Rooted in India's rich agricultural heritage, we work directly with
              experienced farmers and certified suppliers to source the freshest produce
              that meets rigorous international quality standards.
              Every shipment undergoes thorough quality inspection, hygienic packaging,
              and cold-chain logistics to ensure your products arrive in perfect condition.
              Our mission is to bridge the gap between Indian farmlands and global tables —
              delivering not just products, but trust, consistency, and excellence.
              We believe that great trade is built on long-term partnerships, and we are
              committed to offering competitive pricing, reliable timelines, and transparent
              communication at every step.
              Whether you are a wholesale buyer, retail chain, or food processing company,
              <b> Unique Global Exports </b> is your dependable sourcing partner from India.
            </p>
          </div>

          <div className="about-image">
            <div className="image-stack">
              {/* Background images */}
              <img src={images[(currentImage + 1) % images.length]} className="img back1" />
              <img src={images[(currentImage + 2) % images.length]} className="img back2" />

              {/* Main image */}
              <img src={images[currentImage]} className="img front" />
            </div>
          </div>
        </section>

        {/* STATS */}
        <section className="stats-section reveal">
          <div className="stat-card">
            <FontAwesomeIcon icon={faLeaf} className="stat-icon" />
            <h2 className="counter" data-target="2">1+</h2>
            <p>Years Experience</p>
          </div>

          <div className="stat-card">
            <FontAwesomeIcon icon={faGlobe} className="stat-icon" />
            <h2 className="counter" data-target="7">1+</h2>
            <p>Countries Served</p>
          </div>

          <div className="stat-card">
            <FontAwesomeIcon icon={faUsers} className="stat-icon" />
            <h2 className="counter" data-target="500">1+</h2>
            <p>Happy Clients</p>
          </div>

          <div className="stat-card">
            <FontAwesomeIcon icon={faBox} className="stat-icon" />
            <h2 className="counter" data-target="50">1+</h2>
            <p>Export Products</p>
          </div>
        </section>

        {/* MISSION */}
        <section className="mission-section reveal">

          {/* ROW 1 → Mission */}
          <div className="mission-row">
            <div className="mission-text">
              <h2>Our Mission</h2>
              <p>
                To deliver premium-quality
                agricultural products from India to global markets with integrity,
                consistency, and excellence. We are committed to building long-term
                relationships through reliable sourcing, strict quality standards,
                timely delivery, and customer-focused service.
              </p>
            </div>

            <div className="mission-image">
              <img
                src={ourmission}
                alt="Mission"
              />
            </div>
          </div>

          {/* ROW 2 → Vision (reversed) */}
          <div className="mission-row reverse">
            <div className="mission-image">
              <img
                src={ourvision}
                alt="Vision"
              />
            </div>

            <div className="mission-text">
              <h2>Our Vision</h2>
              <p>
                We strive to create lasting value for customers, empower farming
                communities, and promote sustainable agricultural practices that support
                quality, innovation, and global growth for future generations.
              </p>
            </div>
          </div>

        </section>

        {/* GST CERTIFICATE */}
        <section className="gst-section reveal">

          <div className="gst-bg-circle"></div>
          <div className="gst-bg-circle second"></div>

          <div className="gst-content">

            {/* LEFT SIDE */}
            <div className="gst-image">

              <div className="gst-badge">
                VERIFIED
              </div>

              <a
                href={`${gstPdf}#toolbar=0&navpanes=0&scrollbar=0`}
                target="_blank"
                rel="noopener noreferrer"
                className="gst-image-link"
              >
                <img src={gstPreview} alt="GST Certificate" />
              </a>
            </div>

            {/* RIGHT SIDE */}
            <div className="gst-text">

              <span className="gst-subtitle">
                Government Registered Exporter
              </span>

              <h2>
                GST Certification
              </h2>

              <p>
                Unique Global Exports is officially GST registered and
                compliant with Indian export regulations. Our certification
                reflects transparency, trust, and commitment to secure
                international trade operations.
              </p>

              <div className="gst-features">
                <div className="gst-feature">✓ Trusted Export Business</div>
                <div className="gst-feature">✓ Government Verified</div>
                <div className="gst-feature">✓ Transparent Documentation</div>
              </div>

              <div className="gst-buttons">

                <a
                  href={`${gstPdf}#toolbar=0&navpanes=0&scrollbar=0`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="gst-btn"
                >
                  View Certificate
                </a>

                {/* <a
                  href={gstPdf}
                  download
                  className="gst-btn secondary"
                >
                  Download PDF
                </a> */}

              </div>

            </div>

          </div>
        </section>

        {/* CERTIFICATIONS */}
        {/* <section className="certifications reveal">
          <h2>Our Certifications</h2>
          <div className="cert-grid">
            <div className="cert-card">APEDA</div>
            <div className="cert-card">FSSAI</div>
            <div className="cert-card">ISO Certified</div>
            <div className="cert-card">HACCP</div>
          </div>
        </section> */}

      </div>

      <style>{`

/* TITLE */
.about-title {
  font-size: 25px;
  font-weight: 800;
  background: linear-gradient(90deg, #3096ef, #22c55e);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;
}

/* CONTAINER */
.about-container {
  width: 100%;        /* 🔥 full screen width */
  margin: 0;
  padding: 100px 20px 40px;
}

/* HERO */
.about-hero {
  display: flex;
  gap: 50px;
  align-items: center;
  min-height: 80vh;
}

.about-text { flex:1; }

.about-text p {
  font-size: 17px;
  line-height: 1.6;
}

.about-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-stack {
  position: relative;
  width: 100%;
  max-width: 400px;
}

/* All images */
.img {
  width: 100%;
  border-radius: 15px;
  position: absolute;
  transition: 0.5s ease;
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
}

/* Main image */
.front {
  position: relative;
  z-index: 3;
}

/* Background 1 */
.back1 {
  top: 10px;
  left: -15px;
  z-index: 2;
  transform: rotate(-5deg);
  opacity: 0.7;
}

/* Background 2 */
.back2 {
  top: 20px;
  left: -30px;
  z-index: 1;
  transform: rotate(-10deg);
  opacity: 0.5;
}

/* Hover effect 🔥 */
.image-stack:hover .back1 {
  transform: rotate(-8deg) translateX(-5px);
}

.image-stack:hover .back2 {
  transform: rotate(-12deg) translateX(-10px);
}
.about-image { flex:1; }

.about-image img {
  width: 100%;
  border-radius: 15px;
  box-shadow: 0 15px 5px rgba(30, 30, 30, 0.2);
  transition: opacity 0.8s ease-in-out;
}

/* STATS */
.stats-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 30px;
  padding: 80px 10%;
  // background: linear-gradient(135deg, #f8fafc, #ffffff);
}

.stat-card {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  border-radius: 20px;
  padding: 35px 25px;
  text-align: center;
  transition: all 0.4s ease;
  border: 1px solid rgba(255, 255, 255, 0.4);
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  position: relative;
  overflow: hidden;
}

/* subtle glow border effect */
.stat-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 20px;
  padding: 1px;
  background: linear-gradient(120deg, #22c55e, #3b82f6, #f59e0b);
  -webkit-mask: 
    linear-gradient(#fff 0 0) content-box, 
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
          mask-composite: exclude;
  opacity: 0.4;
}

/* hover effect */
.stat-card:hover {
  transform: translateY(-10px) scale(1.03);
  box-shadow: 0 20px 50px rgba(0,0,0,0.15);
}

.stat-icon {
  font-size: 38px;
  margin-bottom: 15px;
  color: #22c55e;
}

.counter {
  font-size: 42px;
  font-weight: 700;
  background: linear-gradient(90deg, #22c55e, #3b82f6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 8px;
}

.stat-card p {
  font-size: 15px;
  color: #555;
  letter-spacing: 0.5px;
}
/* MISSION */
.mission-section {
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.mission-row {
  display: flex;
  align-items: center;
  gap: 50px;
}

/* Reverse row */
.mission-row.reverse {
  flex-direction: row-reverse;
}

.mission-text {
  flex: 1;
}
 .mission-text h2 {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
} 

.mission-image {
  flex: 1;
}

.mission-image img {
  width: 80%;
  border-radius: 15px;
  box-shadow: 0 10px 5px rgba(0,0,0,0.2);
}

/* MOBILE */
@media (max-width: 900px) {
  .mission-row,
  .mission-row.reverse {
    flex-direction: column;
  }
}
  .counter {
  font-size: 30px;
      }

  .stat-card p {
  font-size: 13px;
      }
/* CERTIFICATIONS */
.certifications {
  text-align: center;
}

.cert-grid {
  display: grid;
  grid-template-columns: repeat(4,1fr);
  gap: 20px;
}

.cert-card {
  padding: 25px;
  border-radius: 12px;
  background: white;
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
  transition: 0.3s;
}

.cert-card:hover {
  background: #b9e0ed;
  color: white;
}

/* SCROLL ANIMATION */
.reveal {
  opacity: 0;
  transform: translateY(60px);
  transition: all 0.8s ease;
}

.reveal.active {
  opacity: 1;
  transform: translateY(0);
}
 /* GST SECTION */
.gst-section {
  position: relative;
  padding: 100px 8%;
  overflow: hidden;
}

/* glowing circles */
.gst-bg-circle {
  position: absolute;
  width: 300px;
  height: 300px;
  background: rgba(34,197,94,0.12);
  border-radius: 50%;
  filter: blur(80px);
  top: 0;
  left: -100px;
}

.gst-bg-circle.second {
  background: rgba(59,130,246,0.12);
  right: -100px;
  left: auto;
  bottom: 0;
  top: auto;
}

.gst-content {
  position: relative;
  z-index: 2;

  display: flex;
  align-items: center;
  gap: 70px;

  background: rgba(255,255,255,0.65);
  backdrop-filter: blur(18px);

  border: 1px solid rgba(255,255,255,0.3);

  border-radius: 32px;

  padding: 50px;

  box-shadow:
    0 10px 40px rgba(0,0,0,0.08),
    inset 0 1px 1px rgba(255,255,255,0.4);
}

/* IMAGE */
.gst-image {
  flex: 1;
  position: relative;
}

.gst-image a {
  display: block;
  position: relative;
  text-decoration: none;
}

.gst-image img {
  width: 100%;
  max-width: 380px;
  border-radius: 22px;

  box-shadow:
    0 20px 40px rgba(0,0,0,0.18);

  transition: 0.4s ease;
}

.gst-image:hover img {
  transform: translateY(-8px) scale(1.02);
}

/* verified badge */
.gst-badge {
  position: absolute;
  top: -15px;
  right: 30px;

  z-index: 5;

  background: linear-gradient(90deg,#22c55e,#16a34a);

  color: white;

  padding: 10px 18px;

  border-radius: 50px;

  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;

  box-shadow: 0 10px 20px rgba(34,197,94,0.3);
}

/* overlay */
.preview-overlay {
  position: absolute;
  bottom: 20px;
  left: 20px;

  background: rgba(0,0,0,0.65);

  color: white;

  padding: 12px 18px;

  border-radius: 12px;

  backdrop-filter: blur(10px);

  font-size: 14px;
}

/* TEXT */
.gst-text {
  flex: 1;
}

.gst-subtitle {
  display: inline-block;

  color: #22c55e;

  font-size: 14px;
  font-weight: 700;

  margin-bottom: 12px;

  letter-spacing: 1px;

  text-transform: uppercase;
}

.gst-text h2 {
  font-size: 42px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 20px;

  color: #0f172a;
}

.gst-text p {
  font-size: 17px;
  line-height: 1.8;

  color: #525252;

  margin-bottom: 28px;
}

/* features */
.gst-features {
  display: flex;
  flex-direction: column;
  gap: 12px;

  margin-bottom: 35px;
}

.gst-feature {
  font-size: 15px;
  color: #222;
  font-weight: 500;
}

/* buttons */
.gst-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 25px;
}

.gst-btn {
  padding: 14px 28px;

  border-radius: 14px;

  text-decoration: none;

background: linear-gradient(135deg, #0f172a, #334155);
  color: white;

  font-weight: 600;

  transition: 0.35s ease;

  box-shadow: 0 10px 20px rgba(59,130,246,0.2);
}

.gst-btn:hover {
  transform: translateY(-4px);
}

.gst-btn.secondary {
  background: #111827;
}

/* MOBILE */
@media(max-width:900px) {

  .gst-content {
    flex-direction: column;
    padding: 35px 25px;
    text-align: center;
    gap: 40px;
  }

  .gst-text h2 {
    font-size: 34px;
  }

  .gst-buttons {
    justify-content: center;
  }

  .gst-features {
    align-items: center;
  }

  .preview-overlay {
    left: 50%;
    transform: translateX(-50%);
  }
}

/* MOBILE */
@media(max-width:900px){
  .about-hero,
  .mission-section {
    flex-direction: column;
  }

  .stats-section,
  .cert-grid {
    grid-template-columns: repeat(2,1fr);
  }
}

      `}</style>
      <ExportCountries></ExportCountries>
      <ClientStories></ClientStories>
      <WhatsAppChat />
    </div>
  );
}